

// action - state management
import * as actionTypes from './actions';

export const initialState = {
    template: {
        "super_admin": {
            "label": "Super Admin",
            "actions": {
                "backrr_startups": "Backrr Startups",
                "backrr_startups_delete": "Backrr Startups Delete",
                "backrr_investors": "Backrr Investors",
                "backrr_investors_delete": "Backrr Investors Delete",
                "startup_purchases": "Startup Purchases",
                "backrr_admin_settings_release_notes": "Backrr Admin Settings (Release Notes)",
                "backrr_admin_settings_admin_users": "Backrr Admin Settings (Admin Users)",
                "backrr_admin_settings_promo_codes": "Backrr Admin Settings (Offer Codes)",
                "backrr_admin_settings_plans": "Backrr Admin Settings (Startup Pricing Page)",
                "backrr_admin_settings_profile_score": "Backrr Admin Settings (Profile Score)",
                "backrr_admin_settings_utm_campaigns": "Backrr Admin Settings (UTM Campaigns)",
            },
            "_id": "your_generated_id_here"
        }
    },
    userPermissions: null,
    isOwner: false,
    userName: null
}

const permissionsReducer = (state = initialState, action) => {
    switch (action.type) {
        // case actionTypes.SET_PERMISSION_TEMPLATE:
        //     return {
        //         ...state,
        //         template: action?.data
        //     }
        case actionTypes.SET_USER_ACCESS:
            return {
                ...state,
                userPermissions: action?.permissions,
                isOwner: action?.isOwner,
                userName: action?.userName
            }
        default:
            return state;
    }
}

export default permissionsReducer
